import { render, staticRenderFns } from "./SynonymListSearch.vue?vue&type=template&id=f0719f74&"
import script from "./SynonymListSearch.vue?vue&type=script&lang=js&"
export * from "./SynonymListSearch.vue?vue&type=script&lang=js&"
import style0 from "./SynonymListSearch.vue?vue&type=style&index=0&id=f0719f74&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0719f74')) {
      api.createRecord('f0719f74', component.options)
    } else {
      api.reload('f0719f74', component.options)
    }
    module.hot.accept("./SynonymListSearch.vue?vue&type=template&id=f0719f74&", function () {
      api.rerender('f0719f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SynonymList/components/common/SynonymListSearch.vue"
export default component.exports